import { render, staticRenderFns } from "./SendInspectLog.vue?vue&type=template&id=0acbafa4&scoped=true"
import script from "./SendInspectLog.vue?vue&type=script&lang=js"
export * from "./SendInspectLog.vue?vue&type=script&lang=js"
import style0 from "./SendInspectLog.vue?vue&type=style&index=0&id=0acbafa4&lang=postcss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0acbafa4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\web\\medical\\medical-student\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0acbafa4')) {
      api.createRecord('0acbafa4', component.options)
    } else {
      api.reload('0acbafa4', component.options)
    }
    module.hot.accept("./SendInspectLog.vue?vue&type=template&id=0acbafa4&scoped=true", function () {
      api.rerender('0acbafa4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/operationRecord/sendInspectLog/SendInspectLog.vue"
export default component.exports